<template>
  <div>
    <v-snackbar v-model="showsnackbar" color="#3F033B" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: white">
            {{ msg }}
          </span>
        </v-flex>

        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: #000">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>

    <div class="rates-wrapper">
      <!-- 1. GOLD -->
      <div class="rate-card rate-card-gold" @click="handleCardClick" title="Click to update boarding rates">
        <div class="rate-img-box">
          <img src="../assets/icons/rate_gold.jpg" alt="Gold" class="rate-thumb-img" />
        </div>
        <div class="rate-content">
          <div class="d-flex align-center justify-space-between rate-top-row">
            <span class="rate-label">GOLD</span>
          </div>
          <div class="rate-price">{{ formatCurrency(view.goldRate) }}</div>
        </div>
      </div>

      <!-- 2. SILVER -->
      <div class="rate-card rate-card-silver" @click="handleCardClick" title="Click to update boarding rates">
        <div class="rate-img-box">
          <img src="../assets/icons/rate_silver.jpg" alt="Silver" class="rate-thumb-img" />
        </div>
        <div class="rate-content">
          <div class="d-flex align-center justify-space-between rate-top-row">
            <span class="rate-label">SILVER</span>
          </div>
          <div class="rate-price">{{ formatCurrency(view.silverRate) }}</div>
        </div>
      </div>

      <!-- 3. THANKAM -->
      <div class="rate-card rate-card-thankam" @click="handleCardClick" title="Click to update boarding rates">
        <div class="rate-img-box">
          <img src="../assets/icons/rate_thankam.jpg" alt="Thankam" class="rate-thumb-img" />
        </div>
        <div class="rate-content">
          <div class="d-flex align-center justify-space-between rate-top-row">
            <span class="rate-label">THANKAM</span>
          </div>
          <div class="rate-price">{{ formatCurrency(view.thankamRate) }}</div>
        </div>
      </div>

      <!-- 4. DIAMOND -->
      <div class="rate-card rate-card-diamond" @click="handleCardClick" title="Click to update boarding rates">
        <div class="rate-img-box">
          <img src="../assets/icons/rate_diamond.jpg" alt="Diamond" class="rate-thumb-img" />
        </div>
        <div class="rate-content">
          <div class="d-flex align-center justify-space-between rate-top-row">
            <span class="rate-label">DIAMOND</span>
          </div>
          <div class="rate-price">{{ formatCurrency(view.diamond) }}</div>
        </div>
      </div>

      <!-- 5. PLATINUM -->
      <div class="rate-card rate-card-platinum" @click="handleCardClick" title="Click to update boarding rates">
        <div class="rate-img-box">
          <img src="../assets/icons/rate_platinum.jpg" alt="Platinum" class="rate-thumb-img" />
        </div>
        <div class="rate-content">
          <div class="d-flex align-center justify-space-between rate-top-row">
            <span class="rate-label">PLATINUM</span>
          </div>
          <div class="rate-price">{{ formatCurrency(view.platinumRate) }}</div>
        </div>
      </div>

      <!-- 6. 18-CT -->
      <div class="rate-card rate-card-18ct" @click="handleCardClick" title="Click to update boarding rates">
        <div class="rate-img-box">
          <img src="../assets/icons/rate_18ct.jpg" alt="18-CT" class="rate-thumb-img" />
        </div>
        <div class="rate-content">
          <div class="d-flex align-center justify-space-between rate-top-row">
            <span class="rate-label">18-CT</span>
          </div>
          <div class="rate-price">{{ formatCurrency(view.rate18ct) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import store from "./../store";

export default {
  data() {
    return {
      appLoading: false,
      view: [],
      ServerError: false,
      showsnackbar: false,
      timeout: 3000,
      msg: null,
      billDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
    };
  },
  beforeMount() {
    this.getBording();
  },
  computed: {
    appLogin() {
      return this.$store.state.isLoggedIn;
    },
    appUser() {
      return this.$store.state.email;
    },
    userData() {
      return this.$store.state.userData;
    },
  },
  methods: {
    handleCardClick() {
      this.$root.$emit("open-boarding-rates-dialog");
    },
    formatCurrency(val) {
      const num = Number(val);
      if (val === null || val === undefined || val === "" || isNaN(num) || num <= 0) {
        return "—";
      }
      if (Number.isInteger(num) && num > 100) {
        return "₹ " + num.toLocaleString("en-IN", { maximumFractionDigits: 0 });
      }
      return "₹ " + num.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    getBording() {
      this.appLoading = true;
      axios({
        url: "/rate/view",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          date: this.billDate,
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            this.appLoading = false;
            this.view = response.data.data;
            store.commit("headData", response.data.data);
            localStorage.setItem("diamond", response.data.data.diamond);
            localStorage.setItem("goldRate", response.data.data.goldRate);
            localStorage.setItem("platinumRate", response.data.data.platinumRate);
            localStorage.setItem("silverRate", response.data.data.silverRate);
            localStorage.setItem("thankamRate", response.data.data.thankamRate);
            localStorage.setItem(
              "rate18ct",
              response.data.data.rate18ct ||
                (response.data.data.goldRate
                  ? Math.round((response.data.data.goldRate * 18) / 22)
                  : 0)
            );
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:ital,wght@0,400;0,500;0,600;0,700;0,800;1,400&family=Inter:wght@400;500;600;700&display=swap");

.rates-wrapper {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 10px;
  width: 100%;
}

@media (max-width: 1300px) {
  .rates-wrapper {
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
  }
}

@media (max-width: 768px) {
  .rates-wrapper {
    display: flex !important;
    overflow-x: auto !important;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
    gap: 8px !important;
    padding: 2px 2px 6px 2px !important;
    scrollbar-width: none;
  }
  .rates-wrapper::-webkit-scrollbar {
    display: none;
  }
  .rate-card {
    min-width: 150px !important;
    flex: 0 0 auto !important;
    scroll-snap-align: start;
    padding: 6px 10px !important;
    min-height: 48px !important;
  }
  .rate-img-box {
    width: 32px !important;
    height: 32px !important;
    margin-right: 8px !important;
  }
  .rate-price {
    font-size: 13.5px !important;
  }
}

.rate-card {
  display: flex;
  align-items: center;
  background-color: #ffffff;
  border: 1px solid #eef2f6;
  border-radius: 12px;
  padding: 6px 12px;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
  user-select: none;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);
  min-height: 52px;
  font-family: 'Plus Jakarta Sans', 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
}

.rate-card:hover {
  transform: translateY(-1px);
  border-color: #cbd5e1;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.06);
}

.rate-card-gold:hover {
  border-color: #fcd34d;
}

.rate-card-silver:hover {
  border-color: #cbd5e1;
}

.rate-card-thankam:hover {
  border-color: #fde047;
}

.rate-card-diamond:hover {
  border-color: #93c5fd;
}

.rate-card-platinum:hover {
  border-color: #cbd5e1;
}

.rate-card-18ct:hover {
  border-color: #fdba74;
}

/* Real Image Thumbnail Container */
.rate-img-box {
  width: 38px;
  height: 38px;
  border-radius: 9px;
  background-color: #ffffff;
  border: 1px solid #f1f5f9;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-right: 10px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.rate-thumb-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.25s ease;
}

.rate-card:hover .rate-thumb-img {
  transform: scale(1.08);
}

/* Rate Content */
.rate-content {
  flex: 1;
  min-width: 0;
}

.rate-top-row {
  line-height: 1;
  margin-bottom: 2px;
}

.rate-label {
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.5px;
  color: #64748b;
  text-transform: uppercase;
}

.rate-trend {
  font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
  font-size: 10.5px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  line-height: 1;
  letter-spacing: -0.01em;
}

.rate-trend-positive {
  color: #16a34a;
}

.rate-trend-neutral {
  color: #94a3b8;
  font-size: 12px;
}

.rate-price {
  font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.2;
  white-space: nowrap;
  letter-spacing: -0.02em;
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
}
</style>